import { createAction, props } from '@ngrx/store';
import { SingleGraphError } from 'src/app/common-components/errors/models/error-message';
import { DepartmentDetailSaveModel } from '../../department-details/models/department-detail-save.model';
export const addDepartment = createAction('[Add Department] Add Department');

export const createDepartment = createAction(
   '[Create Department] Create Department',
   props<{ department: DepartmentDetailSaveModel }>()
);

export const createDepartmentSuccess = createAction(
   '[API] Create Department Success',
   props<{ departmentId: number; departmentName: string | null }>()
);

export const createDepartmentFailure = createAction('[API] Create Department Failure', props<SingleGraphError>());
